import { show, hide, trigger } from './utility';

/// show-depends-on-select-other is a special case for show-depends-on-select, this allow the
/// select value to end with Other instead of exact match. (e.g. 'h. Other').
///
/// <div data-gs-toggle="show-depends-on-select-other" data-gs-target="#target"></div>

export default function (targetElem: HTMLElement) {
    let selectName = targetElem.dataset['gsTarget'];
    let selectElems = document.getElementsByName(selectName);
    if (selectElems.length == 0) {
        throw new Error(`Can not find target element: ${selectName}`);
    } else if (selectElems.length > 1) {
        throw new Error(`more than one select element find: ${selectName}`);
    }
    let selectElem = selectElems[0] as HTMLSelectElement;
    if (selectElem.nodeName !== "SELECT") {
        throw new Error(`the target element (${selectName}) has to be a select element`);
    }
    selectElem.addEventListener('change', (event) => {
        if (selectElem.value.toLowerCase().endsWith('other')) {
            show(targetElem);
        } else {
            hide(targetElem);
        }
    });
    trigger(selectElem, 'change', { detail: { init: true } });
}